import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

import { ConsumerProfilePage } from '../../pages/consumer-profile/consumer-profile';
import { PaymentMethodListPage } from '../../pages/payment-method-list/payment-method-list';

@Component({
  selector: 'page-consumer-profile-main',
  templateUrl: 'consumer-profile-main.html',
})
export class ConsumerProfileMainPage {
	profile = ConsumerProfilePage;
	paymentMethods = PaymentMethodListPage;

	constructor(
		public navCtrl: NavController, 
		public navParams: NavParams) {
	}

	ionViewDidLoad() {
		console.log('ionViewDidLoad ConsumerProfileMainPage');
	}

}



// WEBPACK FOOTER //
// ./src/pages/consumer-profile-main/consumer-profile-main.ts